<table class="regions-for-scanning" id="scan-regions-data-table">
  <thead>
    <th>Modality</th>
    <th>Body Part/Procedure</th>
    <th>Phase of Contrast</th>
    <th>Actions</th>
  </thead>
  <tbody>
    @for(scanRegionGroup of scanRegionControlsArray.controls; track index; let
    index = $index) {
    <tr
      app-scan-region
      [scanRegionFields]="scanRegionGroup"
      [modalities]="modalities"
      [bodyParts]="bodyParts"
      [index]="index"
      (scanRegionChange)="onScanRegionChange()"
      (deleteScanRegion)="deleteScanRegion($event)"
    ></tr>
    }
  </tbody>
</table>
